/*
 * Dataset of dually vehicles and their bolt patterns for the
 * Duallys Only Year/Make/Model search.
 *
 * Each entry defines a make, model, year range and the associated
 * bolt pattern. The vehicle-picker.js script uses this dataset
 * to look up the correct bolt pattern and redirect the customer
 * to a search page filtered by that bolt pattern.
 */

window.duallyVehicleData = [
  // Chevrolet and GMC are intentionally separate make choices so the exact
  // vehicle identity is retained for downstream order details and TPMS setup.
  { make: 'Chevy', model: '3500HD Dually', start: 2011, end: 2026, bolt: '8x210' },
  { make: 'GMC', model: '3500HD Dually', start: 2011, end: 2026, bolt: '8x210' },

  { make: 'Ram', model: '3500 Dually', start: 1994, end: 2018, bolt: '8x165.1' },
  { make: 'Ram', model: '3500 Dually', start: 2019, end: 2026, bolt: '8x200' },

  { make: 'Ford', model: 'F-350 Dually', start: 2005, end: 2026, bolt: '8x200' },
  { make: 'Ford', model: 'F-450 Dually', start: 2005, end: 2026, bolt: '10x225' },

  { make: 'Chevy', model: '3500 Dually', start: 1992, end: 2010, bolt: '8x165.1' },
  { make: 'GMC', model: '3500 Dually', start: 1992, end: 2010, bolt: '8x165.1' },

  { make: 'Ford', model: 'F-350 Dually', start: 1988, end: 1997, bolt: '8x165.1' },
  { make: 'Ford', model: 'F-350 Dually', start: 1999, end: 2004, bolt: '8x170' }
];
